import script from "./Checkbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./Checkbox.vue?vue&type=script&lang=ts&setup=true"

import "./Checkbox.vue?vue&type=style&index=0&id=4567503b&lang=scss&scoped=true"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4567503b"]])

export default __exports__